module.exports = {"id":"188802","name":"Marcel Schmelzer","rating":"80","photo":"./data/images/photos/1/188802.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["DG","MG","DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcelSchmelzer0.json
// module id = 2712
// module chunks = 0